import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../../Vas';
import $ from 'jquery';

import CustomerData from './ContractCard/CustomerData';
import CustomerContractDetails from './ContractCard/CustomerContractDetails';
import { ExtendedButton,MessageBox } from 'component-lib';
import { RoleConfiguration,ClosePopUps } from 'utils-lib';
import { RequestAjaxClass, ContractsModel } from 'models-lib';

class ContractCard extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerContractDetails";
        this.Id = props.match.params.contractId;
        this.CustomerId = props.match.params.customerId;
        this.CustomerName = props.match.params.name;
        this.state.RedirectContracts = false;
        this.state.Aktive = false;
        this.state.Unbestaetigt = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this]);
    }

    componentDidMount()
    {
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.ContractsModel.SetRequest(this.Request);

        $("#HeaderTitle").html(Vas.Resources.Labels["Contract"]);
    }

    Update(observer){
      this.setState({},()=>{
        if(observer === "ContractsChange"){
          Vas.GetView("Contracts",true,true);
          $("#LoadingIcon").removeClass().addClass('hide');
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Message={Vas.Resources.Labels["ApproveSuccess"]} 
            Title={Vas.Resources.Titles["Note"]} />
              , document.getElementById('messageContainer'));   
        }
      });
    }

    GetCustomerData(){
        return (<CustomerData id={localStorage.getItem("Id_CurrentCustomer")} />);
    }

    GetCustomerContractDetails(){
        return (<CustomerContractDetails 
          reference={this} 
          Id={this.Id}
          CustomerId={this.CustomerId}
          CustomerName={this.CustomerName} />);
    }

    loadContract(){
      CustomerContractDetails.load();
    }

    GetView(nameOfView){

        ClosePopUps.close();
        this.DeselectTabs();
        switch (nameOfView)
        {
            case "Data":
                this.SelectTab("DataTabLink");
                this.setState({ CurrentView: "CustomerData" });
                break;
            case "Contract":
                this.SelectTab("ContractTabLink");
                this.setState({ CurrentView : "CustomerContractDetails" });
                break;
            default:
                this.SelectTab("DataTabLink");
                this.setState({ CurrentView: "CustomerContractDetails" });
        }
    }

    Accept()
    {
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.ContractsModel.ContractsChangeStatus(this.Id,"",true,false);
    }

    SelectTab(id){
        $("#"+id).removeClass().addClass("activeTab");
    }

    DeselectTabs()
    {
        $("#DataTabLink").removeClass().addClass("tab");
        $("#ContractTabLink").removeClass().addClass("tab");
        $("#PaymentTabLink").removeClass().addClass("tab");
        $("#DocumentTabLink").removeClass().addClass("tab");
    }

    render()
    {
        let role = localStorage.getItem("vas_role");
        let rights = RoleConfiguration.getRoleConfig();
       
        let content = "";
        switch (this.state.CurrentView)
        {
            case "CustomerData":
                content = this.GetCustomerData(localStorage.getItem("Id_CurrentCustomer"));
                break;
            case "CustomerContractDetails":
                content = this.GetCustomerContractDetails();
                break;
            default: content = this.GetCustomerContractDetails(this.Id);
        }

        let actions = [];

        if (role === "3" || role === "99")
        {
            if (rights[2]){
                if (rights[2].Edit === true){
                    if (this.state.Unbestaetigt === true){
                        actions.push(<ExtendedButton 
                          Id={"btoApprove"} 
                          Usable={true} 
                          Float={'right'} 
                          Width={150} 
                          Text={Vas.Resources.Labels["Approve"]} 
                          OnClick={()=>{this.Accept();}} />);
                        actions.push(<ExtendedButton 
                          Id={"btoDecline"} 
                          Usable={true} 
                          Width={150} 
                          Float={'right'} 
                          Text={Vas.Resources.Labels["Decline"]} 
                          OnClick={()=>{Vas.GetView('ContractEditState', {CustomerId : this.CustomerId, ContractId: this.Id, CustomerName : this.CustomerName}, true);}}/>);
                    }
                    /*if (this.state.Aktive === true){
                      if(this.state.FlagLoss === true){

                      }
                        actions.push(<ExtendedButton 
                          Id={"btoLossReport"} 
                          Usable={true} 
                          Width={150} 
                          Float={'right'} 
                          Text={Vas.Resources.Labels["LossReport"]} 
                          OnClick={()=>{ ReactDOM.render(<LossReport 
                            ContractId={this.Id} 
                            me={this} /> 
                            , document.getElementById('popupContainer'));}} />);
                        actions.push(<ExtendedButton 
                          Id={"btoCancel"} 
                          Usable={true} 
                          Width={150} 
                          Float={'right'} 
                          Text={Vas.Resources.Labels["ToCancel"]} 
                          OnClick={()=>{ ReactDOM.render(<ContractCancel 
                            ContractId={this.Id} 
                            me={this} 
                            reference={this} 
                            Function={()=>{this.GetView("Contracts");}} /> 
                                , document.getElementById('popupContainer'));}} />);
                    }*/
                }
            }
        }

        return (
          <div className={"form"} >
            <table className="contractCard">
              <thead>
                <tr>
                  <th 
                    className={"TitleRow"} 
                    style={{ verticalAlign: 'middle' }} 
                    colSpan={2}><div className={"customerCardTitle"}><b> {this.CustomerName }</b>
                      {actions}
                    </div></th>
                  <td style={{ width:'100px' }}><div 
                    id={"LoadingIcon"} 
                    className={'hide'}></div></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={"customerCardLinks"}>
                    <table>
                      <tbody>
                        <tr>
                          <td 
                            id={"ContractTabLink"} 
                            className={"activeTab"} 
                            onClick={()=>{ this.GetView("Contract"); }}>{Vas.Resources.Labels["Contract"]}</td>
                        </tr>
                        <tr>
                          <td 
                            id={"DataTabLink"} 
                            className={"tab"} 
                            onClick={()=>{ this.GetView("Data"); }} >{Vas.Resources.Labels["CustomerData"]}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td 
                    id={"tabContent"} 
                    style={{ verticalAlign: 'top', textAlign:'left' }} >{content}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default ContractCard;
